import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15216">
      <span className="sr-only" data-id="element-15217">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-15218">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-15219" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15220" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-15221">
        <div className="flex gap-8" data-id="element-15222">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-15223">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15224" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15225">
        <div className="space-y-6" data-id="element-15226">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15227">
            <div data-id="element-15228">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-15229" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15230" />
            </div>
            <div data-id="element-15231">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15232" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15233" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-15234">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-15235" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-15236" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15237">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15238">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-15239" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15240" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-15241">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-15242" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15243" />
      </div>
    </div>;
}